// The score that drives alert bands: AI self-confidence until 20+ scored outcomes, then calibrated.
export const bandScore = (x) =>
  (x?.calibrated_n ?? 0) >= 20 && typeof x?.calibrated_score === "number"
    ? { v: x.calibrated_score, src: "calibrated" }
    : { v: x?.confidence_score ?? 0, src: "AI" };
